/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationPricingsDailyBenefitMutation($input: SaveSimulationPricingsDailyBenefit_M_simulation_pricings_daily_benefitInput!) {
    saveSimulationPricingsDailyBenefit_M_simulation_pricings_daily_benefit(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
